import { useEffect, useRef } from "react";

/**
 * Adds .is-visible class on intersection. Use with elements that have the .reveal class.
 */
export default function useReveal(options = { threshold: 0.15 }) {
    const ref = useRef(null);
    useEffect(() => {
        const node = ref.current;
        if (!node) return;
        const obs = new IntersectionObserver((entries) => {
            entries.forEach((e) => {
                if (e.isIntersecting) {
                    e.target.classList.add("is-visible");
                    obs.unobserve(e.target);
                }
            });
        }, options);
        const targets = node.querySelectorAll(".reveal");
        targets.forEach((t) => obs.observe(t));
        return () => obs.disconnect();
    }, []); // eslint-disable-line
    return ref;
}
